var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsraelFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0953369 0.285202V19.7138H26.0001V0.285202H0.0953369Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_233_222",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0953369 0.285202V19.7138H26.0001V0.285202H0.0953369Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_233_222)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0953369 2.71382V5.14239H26.0001V2.71382H0.0953369Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0953369 14.8567V17.2852H26.0001V14.8567H0.0953369Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8995 12.3788H9.30872L13.1417 5.64439L16.8995 12.3788ZM10.6359 11.5624H15.6007L13.1339 7.13365L10.6359 11.5624Z",
    fill: "#3D58DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8369 7.63268H9.21387L13.1582 14.1776L16.8369 7.63268ZM10.6602 8.42174H15.5127L13.1357 12.8583L10.6602 8.42174Z",
    fill: "#3D58DB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsraelFlag);
export default __webpack_public_path__ + "static/media/Israel-Flag.6b682ce6bf92d500b9923abb88061e95.svg";
export { ForwardRef as ReactComponent };